import React from "react";

const MengembangkanKreatifitasScratch: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Di tengah pesatnya perkembangan teknologi, kemampuan berpikir
        logis dan kreatif menjadi keterampilan penting yang perlu diperkenalkan
        sejak usia dini.{" "}
        <a
          href="https://scratch.mit.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Scratch Coding
        </a>{" "} 
        hadir sebagai pendekatan pembelajaran pemrograman yang relevan,
        menyenangkan, dan ramah anak. Melalui bahasa
        pemrograman visual berbasis blok,{" "}
        <a
          href="https://scratch.mit.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Scratch
        </a>{" "}
        membantu anak-anak memahami konsep dasar coding tanpa harus berhadapan
        dengan sintaks yang kompleks, sehingga proses belajar menjadi lebih mudah dan menarik.
      </p>

      <p>
        Perkembangan teknologi saat ini juga ditandai dengan hadirnya inovasi
        berbasis kecerdasan buatan (AI), robotika, dan sistem interaktif.
        Berbagai komunitas dan penyelenggara edukasi teknologi telah menghadirkan 
        program pembelajaran berbasis praktik yang menggabungkan teknologi-teknologi tersebut.
        Dalam konteks ini,{" "}
        <a
          href="https://scratch.mit.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Scratch Coding
        </a> berperan sebagai pintu awal yang tepat untuk mengenalkan 
        logika pemrograman sebelum anak melangkah ke teknologi yang lebih kompleks, 
        sekaligus membangun rasa percaya diri dalam berinteraksi dengan teknologi digital.
      </p>

      <p>
        Melalui kompetisi Scratch Coding yang diselenggarakan oleh Indonesia
        Innovative Technology (IIT), peserta didorong untuk menuangkan ide
        kreatif ke dalam bentuk animasi, game edukatif, dan cerita interaktif.
        Anak-anak tidak hanya ditantang menghasilkan karya yang menarik secara
        visual, tetapi juga menyusun alur logika yang jelas dan memiliki tujuan.
        Pendekatan ini membantu peserta memahami bahwa teknologi dapat menjadi sarana ekspresi ide, 
        pembelajaran, dan pemecahan masalah, bukan sekadar hiburan.
      </p>

      <p>
        Efektivitas pembelajaran berbasis kompetisi juga terlihat pada penyelenggaraan{" "}
        <a
          href="https://infopublik.id/kategori/nasional-sosial-budaya/919828/asean-coding-competition-2025-ajang-berkreasi-digital-gratis-untuk-anak-7-12-tahun?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          ASEAN Coding Competition 2025
        </a>
        , sebuah ajang pemrograman gratis untuk anak usia 7–12 tahun di Asia Tenggara.
        Kompetisi ini menantang peserta membuat proyek Scratch sesuai kelompok usia, 
        seperti tema penjelajahan antariksa dan eksplorasi AI.
        Dengan pendekatan inklusif tanpa biaya pendaftaran, kompetisi ini membuka 
        kesempatan luas bagi anak-anak untuk belajar berpikir kreatif dan logis melalui proyek interaktif.
      </p>

      <p>
        Pentingnya pengenalan coding sejak dini sejalan dengan arah kebijakan pendidikan nasional
        yang mulai memasukkan AI dan coding dalam pengembangan kurikulum. Sejalan dengan hal tersebut,
        IIT bersama{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>{" "}
        menghadirkan ekosistem pembelajaran teknologi yang terstruktur dan berkelanjutan.
        Melalui Scratch Coding, pelajar tidak hanya mempelajari dasar pemrograman, tetapi juga 
        mengembangkan keterampilan abad ke-21 seperti berpikir komputasional, kreativitas, dan 
        komunikasi ide sebagai bekal menghadapi tantangan teknologi masa depan.
      </p>

      {/* <p className="font-medium">
        👉 Cek untuk informasi lomba <span className="text-blue-600">pemrograman scratch</span> lebih lanjut
      </p> */}
    </div>
  );
};

export default MengembangkanKreatifitasScratch;
